import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

export type MessageMySalesOwnerPayload = {
  message: string;
  regardingOpportunityId?: string;
  pageUrl: string;
};

export const messageMySalesOwner = (options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();
  const { defaultOnMutateSuccess } = useAPQuery();

  return useMutation({
    mutationFn: (payload: MessageMySalesOwnerPayload) => {
      return fetchWithAuth("messageMySalesOwner", undefined, {
        requestOptions: {
          method: "post",
          body: JSON.stringify(payload),
        },
      });
    },
    onMutate: defaultOnMutateSuccess(options),
  });
};
